import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DatePicker from "../components/DatePicker";
import {
  load_patient_grouped_quotes,
  update_quote_status,
} from "../actions/agenda_content";
import { tableHeaders } from "../hooks/constants";
import TableContainer from "../containers/Tables/TableContainer";
import { usePatientNavigation } from "../hooks/useDetailNavigation";
import { checkAuthenticated } from "../actions/auth";
import { Button, Form } from "react-bootstrap";
import ChartContainer from "../containers/ChartContainer";
const weekday_names = {
  1: "Domingo",
  2: "Lunes",
  3: "Martes",
  4: "Miércoles",
  5: "Jueves",
  6: "Viernes",
  7: "Sábado",
};

const StatsPage = () => {
  const dispatch = useDispatch();
  const [patientGroupedList, setPatientGroupedList] = useState([]);
  const [textSearch, setTextSearch] = useState("");

  const nowDate = new Date();
  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });

  const [selectedAction, setSelectedAction] = useState("updatePagado");
  const [checkedPatients, setCheckedPatients] = useState([]);
  const [chartsData, setChartsData] = useState({
    weekday_count: [],
    hour_count: [],
    service_count: [],
    summary_quotes: {},
  });
  const { goToPatientDetail } = usePatientNavigation();

  const fetchPatienGroupedtList = async () => {
    const { year, month } = dateValues;

    const data = await load_patient_grouped_quotes({
      year,
      month,
      textSearch,
    });
    if (data) {
      setPatientGroupedList(data.results);
      const transformedServiceCount = data.service_count?.map((item) => {
        return {
          x: item["service"],
          y: item.count,
          l: item["name"],
        };
      });
      const transformedSummaryCount = Object.entries(data.summary_quotes).map(
        ([key, value]) => {
          const colores = {
            confirmado: "#02C39A",
            pendiente: "#ffc13b",
            cancelado: "#F44336",
          };
          const countName = key.charAt(0).toUpperCase() + key.slice(1);
          return {
            name: countName, 
            value: value,
            fill: colores[key],
          };
        }
      );
      const transformedWeekdayData = data.weekday_count?.map((item) => {
        return {
          x: weekday_names[item.weekday],
          y: item.count,
        };
      });
      const transformedHourData = data.hour_count?.map((item) => {
        const hourPoint = item.hour.split(":");
        item.hour = hourPoint[0] + ":" + hourPoint[1];
        return {
          x: item.hour,
          y: item.count,
        };
      });
      setChartsData({
        weekday_count: transformedWeekdayData,
        hour_count: transformedHourData,
        service_count: transformedServiceCount,
        summary_quotes: transformedSummaryCount,
      });
    }
  };
  const handleSearch = () => {
    fetchPatienGroupedtList();
  };

  const handleSelectChange = (event) => {
    setSelectedAction(event.target.value);
  };
  const handleUpdateCheckedPatients = async (checkedList, updateValue) => {
    if (checkedList.length === 0) {
      setCheckedPatients([]);
      return;
    }
    const stringList = checkedList.join(",");

    const filterData = { patients: stringList, ...dateValues };
    const bodyData = {
      status_payment: updateValue,
    };

    await update_quote_status(filterData, bodyData).then(
      fetchPatienGroupedtList()
    );
  };

  const handleCheckedAction = (patients) => {
    switch (selectedAction) {
      case "updatePagado":
        handleUpdateCheckedPatients(patients, "pagado");
        break;
      case "updatePendiente":
        handleUpdateCheckedPatients(patients, "pendiente");
        break;
      default:
        console.log("No action selected or recognized");
    }
  };

  const tableConfigTransactions = {
    headers: tableHeaders.employeePatientsTable,
    checkable: true,
    detailFunction: goToPatientDetail,
    listData: patientGroupedList,
    checkedList: checkedPatients,
    setCheckedList: setCheckedPatients,
  };
  useEffect(() => {
    dispatch(checkAuthenticated());
    fetchPatienGroupedtList();
  }, [dateValues]);
  return (
    <div className="content">
      <div className="d-flex align-items-center page-title gap-2">
        <h1>Estadisticas</h1>
        <DatePicker dateValues={dateValues} setDateValues={setDateValues} />
      </div>
      <div className="list-header d-flex justify-content-between mb-2">
        <h4>Reporte total mensual</h4>
      </div>
      <div className="input-group mb-3">
        {/* <Button variant="outline-secondary">Filtros y Ordenamiento</Button> */}

        <input
          type="text"
          className="form-control"
          placeholder="Buscar por Apellidos, Rut o Nombre"
          onChange={(e) => setTextSearch(e.target.value)}
        />
        <Button
          className="d-flex gap-2"
          variant="outline-secondary"
          onClick={handleSearch}
        >
          <i className="bi bi-search"></i>
          Buscar / Refrescar
        </Button>
      </div>
      <TableContainer tableConfig={tableConfigTransactions} />
      <div className="quotes-table-footer d-flex justify-content-end my-2">
        <div className="d-flex table-options gap-2">
          <Form.Select
            aria-label="Default select example"
            onChange={handleSelectChange}
            value={selectedAction}
          >
            <option value="updatePagado">Marcar Como Pagado</option>
            <option value="updatePendiente">Marcar Como Pendiente</option>
          </Form.Select>
          <Button
            variant="primary d-flex align-items-center gap-2"
            onClick={(e) => handleCheckedAction(checkedPatients)}
          >
            Confirmar Accion
          </Button>
        </div>
      </div>
      <ChartContainer chartsData={chartsData} />
    </div>
  );
};

export default StatsPage;
